<div class="flex overflow-hidden h-full">
    <form [formGroup]="createCustomFilterForm" class="flex overflow-hidden h-full gap-20 w-full">
        <div class="h-full w-28rem bg-white flex flex-column border-round-lg">
            <div class="flex align-items-center justify-content-between p-4">
                <p class="text-semibold m-2 text-lg">
                    {{ (updatefilter ? 'default-cm-edit' : 'default-cm-create') | translate }}
                    Custom List
                </p>
                @if (!updatefilter) {
                    <p-button styleClass="shadow-none" [text]="true" (click)="clearAll()">{{
                        'default-cm-clearAll' | translate: 'Clear All'
                    }}</p-button>
                }
            </div>
            <div class="overflow-scroll">
                <div class="flex flex-column px-4 h-full pb-8">
                    <span class="p-float-label w-full mt-1">
                        <input
                            pInputText
                            type="text"
                            formControlName="name"
                            placeholder="{{ 'default-admin-filter-name' | translate: 'List name' }}"
                            class="height-40 w-full"
                            trim="blur"
                        />
                        <label htmlFor="page-name">{{ 'default-admin-filter-name' | translate: 'List name' }}</label>
                    </span>
                    @if (createCustomFilterForm.get('name')?.value?.length > 255) {
                        <span class="text-red-500 px-2">
                            {{ 'default-character-exceed' | translate: 'Cannot exceed 255 characters' }}
                        </span>
                    } @else if (
                        createCustomFilterForm.controls['name'].touched &&
                        createCustomFilterForm.controls['name'].errors
                    ) {
                        @if (createCustomFilterForm.controls['name'].errors['required']) {
                            <span class="text-red-500 text-sm px-2">{{
                                'default-admin-filter-listName-required-message' | translate: 'Please enter List name'
                            }}</span>
                        }
                    }
                    <span class="p-float-label mt-3 w-full">
                        <textarea
                            class="w-full"
                            pInputTextarea
                            rows="5"
                            formControlName="description"
                            placeholder="{{ 'default-cm-description' | translate: 'Description' }}"
                        ></textarea>
                        <label htmlFor="page-name">{{ 'default-cm-description' | translate: 'Description' }}</label>
                    </span>
                    <span class="flex text-sm align-content-center justify-content-between px-2">
                        <span>
                            @if (createCustomFilterForm.get('description')?.value?.length > 255) {
                                <span class="text-red-500">
                                    {{ 'default-character-exceed' | translate: 'Cannot exceed 255 characters' }}
                                </span>
                            } @else if (
                                createCustomFilterForm.get('description')?.touched &&
                                createCustomFilterForm.get('description')?.errors
                            ) {
                                <span class="text-red-500">{{
                                    'default-admin-filter-listDescription-required-message'
                                        | translate: 'Please enter description'
                                }}</span>
                            }
                        </span>
                        <span class="text-sm"
                            >{{ createCustomFilterForm.get('description')?.value?.length || 0 }}/255</span
                        >
                    </span>

                    <div class="flex flex-column gap-1 mt-3">
                        <span class="text-sm text-gray-300"
                            >{{ 'default-admin-filter-queueSouceLabel' | translate: 'Select the List?*' }}
                        </span>
                        <p-dropdown
                            [options]="inboxTypes"
                            [filter]="true"
                            [formControlName]="'inboxListType'"
                            [group]="true"
                            id="to"
                            placeholder="{{
                                'default-admin-filter-queueSoucePlaceholder' | translate: 'Choose the List source'
                            }}"
                            optionLabel="label"
                            optionValue="value"
                            optionDisabled="disabled"
                            styleClass="height-40 w-full"
                            [disabled]="updatefilter"
                            (onChange)="onChangeInboxType($event)"
                            appendTo="body"
                        >
                            <ng-template let-option pTemplate="selectedItem">
                                <span class="p-2">
                                    {{ option.lang | translate: option.label }}
                                </span>
                            </ng-template>
                            <ng-template let-group pTemplate="group">
                                <span class="p-2" style="color: var(--alpha-text-inactive-color)">
                                    {{ group.lang | translate: group.label }}
                                    {{ group.suffix ? ('default-cm-inbox' | translate: 'Inbox') : '' }}
                                </span>
                            </ng-template>
                            <ng-template let-item pTemplate="items">
                                <span class="p-2">
                                    {{ item.lang | translate: item.label }}
                                </span>
                            </ng-template>
                            <ng-template pTemplate="empty">
                                <img src="assets/icons/no-result-found.svg" alt="" />
                                {{ 'default-cm-noResultFound' | translate: 'No results found' }}
                            </ng-template>
                        </p-dropdown>
                    </div>
                    @if (
                        createCustomFilterForm.controls['inboxListType'].touched &&
                        createCustomFilterForm.controls['inboxListType'].errors?.['required']
                    ) {
                        <span class="text-red-500 text-sm">{{
                            'default-admin-filter-listSource-required-message' | translate: 'Please select List source'
                        }}</span>
                    }

                    <div class="flex mt-3 flex-column gap-4 w-full surface-ground h-full text-gray-300">
                        @for (page of categories; track pIndex; let pIndex = $index) {
                            <div class="w-full flex flex-column gap-2 w-full surface-ground">
                                <div class="flex flex-column gap-2">
                                    <div class="flex align-items-start w-full">
                                        <span class="text-medium text-sm line-height-3 text-gray-200">{{
                                            page.lang | translate: page.categoryMenu
                                        }}</span>
                                    </div>
                                    <div
                                        class="w-full border-round-lg flex flex-column surface-border border-1 justify-content-center"
                                    >
                                        @for (singlePage of page.items; track i; let i = $index) {
                                            <div
                                                class="hover:surface-hover h-4rem  p-3 flex surface-border align-items-center cursor-pointer justify-content-between {{
                                                    page.items.length - 1 == i ? '' : 'border-bottom-1'
                                                }}"
                                                [ngClass]="{
                                                    'text-primary-700 surface-600':
                                                        activePageMenu['activeMenuCategory'] === pIndex &&
                                                        activePageMenu['activeCategoryItem'] === i,
                                                }"
                                                (click)="setMenu(pIndex, i, singlePage)"
                                            >
                                                <div class="flex align-items-center justify-content-center gap-2">
                                                    <img
                                                        class="w-2 h-2"
                                                        [src]="
                                                            activePageMenu['activeMenuCategory'] === pIndex &&
                                                            activePageMenu['activeCategoryItem'] === i
                                                                ? 'assets/icons/' + singlePage?.activeIcon
                                                                : 'assets/icons/' + singlePage?.icon
                                                        "
                                                    />
                                                    <span class="font-medium capitalize white-space-nowrap">
                                                        {{ singlePage.lang | translate: singlePage.title }}</span
                                                    >
                                                    <img
                                                        [pTooltip]="tooltipContent"
                                                        [src]="
                                                            activePageMenu['activeMenuCategory'] === pIndex &&
                                                            activePageMenu['activeCategoryItem'] === i
                                                                ? 'assets/icons/info.svg'
                                                                : 'assets/icons/info-non-active.svg'
                                                        "
                                                    />
                                                    <ng-template #tooltipContent>
                                                        <div class="flex align-items-center">
                                                            {{
                                                                singlePage.info.lang
                                                                    | translate: singlePage.info.default
                                                            }}
                                                        </div>
                                                    </ng-template>
                                                </div>
                                                @if (
                                                    activePageMenu['activeMenuCategory'] === pIndex &&
                                                    activePageMenu['activeCategoryItem'] === i
                                                ) {
                                                    <i class="pi pi-angle-right text-lg"></i>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="flex w-full gap-3 px-4 py-3">
                <div class="flex-1">
                    <p-button
                        label="{{ 'default-cm-cancel' | translate: 'Cancel' }}"
                        [outlined]="true"
                        styleClass="w-full"
                        (onClick)="onCancel()"
                    ></p-button>
                </div>
                <div class="flex-1">
                    <p-button
                        [label]="
                            updatefilter
                                ? ('default-cm-update' | translate: 'Update')
                                : ('default-cm-create' | translate: 'Create')
                        "
                        styleClass="w-full"
                        [disabled]="createCustomFilterForm.invalid"
                        (onClick)="onSubmit()"
                    ></p-button>
                </div>
            </div>
        </div>
        @if (sideBar) {
            <div
                class="flex flex-column bg-white border-round-lg overflow-hidden"
                [ngClass]="selectTabMenu.label === 'filters' ? 'flex-1' : 'w-30rem'"
            >
                <div class="flex justify-content-between p-4 pb-0 w-full">
                    @for (item of headers; track $index) {
                        @if ($index == activeMenuIndex) {
                            <div class="flex flex-column">
                                <p class="text-semibold m-2 text-lg">{{ item.title | translate: item.defaultTitle }}</p>
                                <p class="m-2 text-lg">{{ item.description | translate: item.defaultDescription }}</p>
                            </div>
                        }
                    }
                    <span class="flex align-items-center gap-2">
                        @if (selectTabMenu.label === 'filters') {
                            <span class="flex align-items-center">
                                <p-selectButton
                                    id="filterTypeSelectButton"
                                    [options]="filterTypeOptions"
                                    [(ngModel)]="selectedFiltersType"
                                    [ngModelOptions]="{ standalone: true }"
                                >
                                    <ng-template pTemplate="item" let-item>
                                        <span>{{ item.lang | translate: item.label }}</span>
                                    </ng-template>
                                </p-selectButton>
                            </span>
                        }
                        <p-button
                            styleClass="shadow-none height-40"
                            icon="pi pi-times"
                            (onClick)="close()"
                            [text]="true"
                        ></p-button>
                    </span>
                </div>

                @if (selectTabMenu.label === 'filters') {
                    <div class="p-2 w-full flex flex-column flex-1 overflow-auto">
                        <app-edit-cutom-filter
                            class="w-full"
                            [filterArray]="selectedInboxFilters"
                            [selectedFilters]="createCustomFilterForm.get('filters')?.value || {}"
                            [selectedAdditionalFilters]="createCustomFilterForm.get('additionalFilters')?.value || {}"
                            (onChangeFilter)="onChangeFilters($event)"
                            [selectedFilterType]="selectedFiltersType"
                        ></app-edit-cutom-filter>
                    </div>
                } @else {
                    <app-checkbox-list
                        class="flex flex-column overflow-hidden flex-1"
                        [items]="selectTabMenu.filterData"
                        [labelKey]="selectTabMenu.label"
                        [showSelectAll]="true"
                        (searchChange)="filter($event)"
                        [showSearch]="true"
                        (selectionChange)="onSelect($event)"
                        (selectAllChange)="onSelectAll($event)"
                        [showMoreEnabled]="true"
                        [allLoaded]="allLoaded"
                        [loadMoreError]="loadMoreError"
                        (loadMore)="onLoadMore()"
                    />
                }
            </div>
        }
    </form>
</div>
